import { render, staticRenderFns } from "./COD-Branch-Detail.vue?vue&type=template&id=90c2cc8a&scoped=true"
import script from "./COD-Branch-Detail.vue?vue&type=script&lang=js"
export * from "./COD-Branch-Detail.vue?vue&type=script&lang=js"
import style0 from "./COD-Branch-Detail.vue?vue&type=style&index=0&id=90c2cc8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c2cc8a",
  null
  
)

export default component.exports